export default __webpack_public_path__ + "static/media/Cut In.86ae33d9.png";